import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Container = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    min-height: 38px;
    height: auto;
`

// eslint-disable-next-line no-restricted-globals
export const AutoComplete = styled.div<{top: number}>`
    position: absolute;
    left: 0;
    top: ${(props) => props.top || "38px"};
    max-height: 300px;
    width: 100%;
    background-color: #ffffff;
    z-index: 999999;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1),
    0px 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: 0px 0px 8px 8px;
    padding: 0px;
    overflow-y: auto;
    height: auto;
`

export const AutoCompleteList = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
`
export const AutoCompleteItem = styled.li`
    width: 100%;
    padding: 8px;
    border-bottom: 1px solid rgba(0,0,0,.1);
    cursor: pointer;
    transition: all .5s;
    &:hover{
        background-color: rgba(0,0,0,.1);
    }
`

export const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    border-top-right-radius: 10px;
    border-bottom-right-radius:  10px;
`

export const InputIcon= styled(FontAwesomeIcon)`
    width: 16px;
    height: 16px;
`



export const VisualContainer = styled.div`
    border: 1px solid #ced4da;
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    padding: 2px;
    z-index: 999999;
`

export const TextInput = styled.textarea`
    min-height: 38px;
    height: auto;
    overflow: hidden;
    resize: none;
    width: 100%;
    border: none;
    outline: none;
    padding: 0.375rem 0.75rem;
    background-clip: padding-box;
    line-height: 1.5;
    font-weight: 400;
    background-color: #ffffff;
    &:focus ~ ${VisualContainer}{
        border-color: rgb(127.5, 189, 255);
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
`

